var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameMenuPlay = function SvgIconStorygameMenuPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.387a1 1 0 0 1 1.561-.827l11.22 7.612a1 1 0 0 1 0 1.655L7.06 20.44a1 1 0 0 1-1.561-.827V4.387Z",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};
export default SvgIconStorygameMenuPlay;